import { Component, OnInit, ViewEncapsulation, input, model, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ApThemeService } from '@ap/theme';
import { ApContentService } from '@ap/content';
import { ApIconLinkComponent } from '@ap/icon-link';
import { ApContentPipe } from '@ap/content';
import { ApPhonePipe } from '@ap/pipes';

import { AdvisorDetails } from '../contact-info.model';
import { ApPhoneLinkComponent } from '../phone-link/phone-link.component';

import content from './contact-info.content.json';

const hasAdvisors = ['reb', 'blg'];

/**
 * @module ApContactInfoModule
 * @ngdoc component
 * @name ApContactInfoComponent
 */
@Component({
    selector: 'ap-contact-info',
    templateUrl: 'contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgTemplateOutlet, ApIconLinkComponent, ApPhoneLinkComponent, ApContentPipe, ApPhonePipe]
})
export class ApContactInfoComponent implements OnInit {
    private readonly contentService = inject(ApContentService);
    private readonly themeService = inject(ApThemeService);

    /**
     * Details of the advisor
     */
    public readonly advisor = input<AdvisorDetails>(undefined);

    /**
     * Should advisor details be shown?
     */
    public readonly showAdvisor = model(true);

    public constructor() {
        const contentService = this.contentService;

        contentService.addContentItems(content);
    }

    public ngOnInit() {
        if (this.showAdvisor() && !hasAdvisors.includes(this.themeService.getTheme())) {
            this.showAdvisor.set(false);
        }
    }

    protected get phoneNumber() {
        return this.contentService.get('contact.info.phonenumber');
    }

    protected get contactPage() {
        return this.contentService.get('contact.info.customer.support.message', { url: this.contactPageUrl });
    }

    private get contactPageUrl() {
        return this.contentService.get('contact.info.customer.support.url');
    }
}
